import type React from 'react';

import { ClientRender } from '@change-corgi/core/react/ssr/render';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';

import type { SupporterComment, SupporterCommentPetition } from '../../../../shared/types';
import { CommentLikes } from '../../../CommentLikes';
import { ReportComment } from '../../../ReportComment';

export const SupporterCommentCardFooter: React.FC<{
	supporterComment: SupporterComment;
	petition: SupporterCommentPetition;
}> = ({ supporterComment, petition }) => {
	const isSunriseThemeEnabled = useIsSunriseTheme();

	return (
		<ClientRender placeholder={<Box sx={{ height: 24 }} />}>
			<Flex sx={isSunriseThemeEnabled ? { gap: '16px' } : { gap: '10px' }}>
				<CommentLikes comment={supporterComment} />
				<ReportComment comment={supporterComment} petitionId={petition.id} petitionSlug={petition.slug} />
			</Flex>
		</ClientRender>
	);
};
